import {
	USER,
	SIGNIN,
	ROUTE,
	TOKEN,
	ADMIN_USERNAME,
	ADMIN_TOKEN
}
from '../constants';

export const setUser = (text) => ({ type: USER, payload: text })

export const setSignin = (text) => ({ type: SIGNIN, payload: text })

export const setRoute = (text) => ({ type: ROUTE, payload: text })

export const setToken = (text) => ({ type: TOKEN, payload: text })

export const setAdminUsername = (text) => ({ type: ADMIN_USERNAME, payload: text })

export const setAdminToken = (text) => ({ type: ADMIN_TOKEN, payload: text })

